import React, { useEffect, useState } from "react";
import MainButton from "../../../components/button/mainButton";
import { TextBox, Input } from "../../../components/textfield";
import HeaderBar from "../../../components/header/headerBar";
import { useHistory } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiPlusCircle, mdiPrinter, mdiCloseCircle } from "@mdi/js";
import "../../../assets/styles/components/select.scss";
import EmptyModel from "../../../components/modal/emptyModal";
import { Table, TableColumn } from "../../../components/table";
import { Form, Select, Typography } from "antd";
import "../../../assets/styles/admin/usedcourse.scss";
const { Option } = Select;
const { Title, Text } = Typography;
const data = [
  {
    id: "1",
    name: "Doctor(DF%)",
    storename: [],
  },
  {
    id: "2",
    name: "Nurse",
    storename: [],
  },
  {
    id: "3",
    name: "Therapist",
    storename: [],
  },
  {
    id: "4",
    name: "Therapist2",
    storename: [],
  },
  {
    id: "5",
    name: "คลีนหน้า/Clean",
    storename: [],
  },
  {
    id: "6",
    name: "แปะยาชา",
    storename: [],
  },
  {
    id: "7",
    name: "ล้างแผล/Dressing",
    storename: [],
  },
  {
    id: "8",
    name: "Anesthiologist(1=4800,15ml)...",
    storename: [],
  },
  {
    id: "9",
    name: "Assistant Anesth",
    storename: [],
  },
];
const CourseProList1 = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [Selected, setSelected] = useState<string>("");
  const [state, setState] = useState<any>(data);
  const [selectNum, setSelectNum] = useState<number>(0);
  const username = [{ value: "", name: "น.ส ธันยรัศมิ์ จิระรุ่งโรจน์" }];
  const admin = [{ value: "", name: "กษิรา สายพรชัย (หมอแบล์)" }];
  const branch = [{ value: "", name: "สาธร" }];
  const nurse = [
    { value: "", name: "นิมล วาสุทา1" },
    { value: "", name: "นิมล วาสุทา2" },
    { value: "", name: "นิมล วาสุทา3" },
  ];
  const columns = [
    {
      title: "ตำแหน่ง",
    },
    {
      title: "ชื่อผู้ดำเนินการ/Operator",
    },
  ];
  useEffect(() => {
    getAPIs();
  }, []);
  const getAPIs = async () => {
    // api 1
    // api 2
    // const _data = await axios.get('/courses')
    // const procedureTypes = await axios.get('/procedureTypes')
    //setState(_dataoperator);
  };
  function onClose() {
    setIsOpen(false);
  }
  function onClose2() {
    setIsOpen2(false);
  }
  function addOperator() {
    // const xOperator = state.OperatorTable;
    // console.log("X", xOperator);

    state[selectNum].storename.push(Selected);
    setState([...state]);
    console.log("state ", state);

    // setState({ ...state, state });
  }
  const handleChange = (e: any) => {
    console.log("e", e);
    setSelected(e);
  };
  const removename = (index1: any, index2: any) => {
    console.log("index", index1, index2);

    state[index1].storename.splice(index2, 1);
    setState([...state]);
    console.log("remove", state);
  };

  return (
    <div>
      <HeaderBar title="USED COURSE / Acne Clear" btnBack />
      {/* <ConFirmModal type={1} show={showModal1} onClose={toggleModal1} /> */}
      <EmptyModel show={isOpen} onClose={onClose} width="40%">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 20px",
          }}
        >
          <h4>Choose</h4>

          <Form form={form} initialValues={{}} layout="vertical">
            <div className="row justify-center mt-40">
              <Title level={5} style={{ color: "#4D7E7F" }}>
                พยาบาล
              </Title>
              <Select
                id="select"
                defaultValue="กรุณาเลือกชื่อ"
                style={{ width: "100%" }}
                onChange={handleChange}
              >
                {nurse.map((m: any, i: number) => (
                  <Option value={m.name}>{m.name}</Option>
                ))}
              </Select>
            </div>

            <div className="justify-center mt-40">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก"
                onClick={() => {
                  setIsOpen(false);
                }}
              />
              <MainButton
                className="mg-10"
                title="ยืนยัน"
                background="#4D7E7F"
                onClick={() => {
                  //console.log("");
                  addOperator();
                  setIsOpen(false);
                }}
              />
            </div>
          </Form>
        </div>
      </EmptyModel>

      <EmptyModel show={isOpen2} onClose={onClose2} width="40%">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "40px 20px",
          }}
        >
          <h4>Date Used</h4>
          <div className="row justify-center">10-09-2021</div>
          <div className="row justify-center">(10 September 2021)</div>
          <div className="row justify-center">10 : 00 am</div>
          <div className="justify-center mt-20">
            <MainButton
              className="mg-10"
              background="#E76464"
              title="ยกเลิก"
              onClick={() => {
                setIsOpen2(false);
              }}
            />
            <MainButton
              className="mg-10"
              background="#4D7E7F"
              title="ยืนยัน"
              onClick={() => history.push(`/usedcourse/Coursedetail/1`)}
            />
          </div>
        </div>
      </EmptyModel>

      <div className="row" style={{ padding: "20px 20px" }}>
        <div style={{ marginTop: "20px" }}>
          <div className="container justify-content-space-between">
            <div className="row justify-content-center">
              <div className="card col-6">
                <div className="card-body">
                  <div className="row mt-20">
                    <TextBox
                      className="col-6 text-box-usedc"
                      title="Course Card ID"
                      value="R9-CNT61080007"
                    />
                    <TextBox
                      className="col-6 text-box-usedc"
                      title="เลขที่ใบยา/Ref"
                      value="xxxxxx"
                    />
                  </div>
                  <div className="row mt-20" style={{ padding: "10px 0px" }}>
                    <TextBox
                      className="col-6 text-box-usedc"
                      title="จำนวน/Number"
                      value="30,000"
                    />
                    <Input
                      className="col-6 input-usedc"
                      type="date"
                      title="DATE"
                      value="2564-09-10"
                    />
                  </div>
                </div>
              </div>
              <div className="card col-md-6">
                <div className="card-body">
                  <div className="row mt-20">
                    <div
                      className="col-6 text-box-usedc-cus"
                      style={{ padding: "0px" }}
                    >
                      <TextBox title="ผู้ใช้/Customer" value="R9-CNT61080007" />
                    </div>
                    <div
                      className="col-6 mt-20"
                      style={{ padding: "10px 10px" }}
                    >
                      <Select
                        defaultValue="กรุณาเลือกชื่อ"
                        style={{ width: 225, fontSize: 18 }}
                        onChange={handleChange}
                      >
                        {username.map((m: any, i: number) => (
                          <Option value={m.name}>{m.name}</Option>
                        ))}
                      </Select>
                    </div>
                  </div>

                  <div className="row mt-20">
                    <div className="row">
                      <div
                        className="col-6 mt-10"
                        style={{ padding: "0px 20px" }}
                      >
                        <Text style={{ color: "#5BAEA9", fontSize: 14 }}>
                          {"ผู้ดูแล"}
                        </Text>
                        <Select
                          defaultValue="ผู้ดูแล"
                          style={{ width: 225, fontSize: 18 }}
                          onChange={handleChange}
                        >
                          {admin.map((m: any, i: number) => (
                            <Option value={m.name}>{m.name}</Option>
                          ))}
                        </Select>
                      </div>
                      <div
                        className="col-6 mt-10"
                        style={{ padding: "0px 20px" }}
                      >
                        <Text style={{ color: "#5BAEA9", fontSize: 14 }}>
                          {"สาขา"}
                        </Text>
                        <Select
                          defaultValue="สาขา"
                          style={{ width: 225, fontSize: 18 }}
                          onChange={handleChange}
                        >
                          {branch.map((m: any, i: number) => (
                            <Option value={m.name}>{m.name}</Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    {/* <Select className="col-6" title="มอบโดย" option={admin} />
                    <Select className="col-6" title="สาขา" option={branch} /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "50px" }}>
          <div className="container">
            <Table header={columns}>
              {state.map((item: any, index: any) => (
                <tr
                  key={index}
                  // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                  style={{ cursor: "pointer" }}
                >
                  <TableColumn width="50%">{item.name}</TableColumn>
                  <TableColumn width="50%">
                    <div
                      className="font-text-value"
                      style={{
                        display: "flex",
                        justifyContent: "left",
                      }}
                    ></div>

                    <div className="d-flex justify-content-between ">
                      <div>
                        {item.storename.map((name: any, in2: number) => (
                          <span onClick={() => removename(index, in2)}>
                            {name}
                            <Icon
                              path={mdiCloseCircle}
                              size="24"
                              color="#E76464"
                            />
                          </span>
                        ))}
                      </div>
                      <div
                        className="font-text-value"
                        style={{
                          display: "flex",
                          justifyContent: "right",
                        }}
                      >
                        {item.storename.length < 2 && (
                          <div
                            onClick={() => {
                              setSelectNum(index);
                              //addOperator(index);
                              setIsOpen(true);
                            }}
                          >
                            <Icon
                              path={mdiPlusCircle}
                              size="27"
                              color="#4D7E7F"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </TableColumn>
                </tr>
              ))}
            </Table>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <MainButton
              title="ย้อนกลับ"
              background="#E76464"
              className="mg-10"
              onClick={() => history.push(`/usedcourse/1`)}
            />
            <MainButton
              title="พิมพ์ใบเซ็น"
              background="#4285F4"
              className="mg-10"
            >
              <Icon path={mdiPrinter} size="20" color="#fff" />
            </MainButton>
            <MainButton
              title="พิมพ์ใบยา"
              background="#4285F4"
              className="mg-10"
            >
              <Icon path={mdiPrinter} size="20" color="#fff" />
            </MainButton>
            <MainButton
              title="ยืนยัน"
              background="#4D7E7F"
              className="mg-10"
              onClick={() => {
                setIsOpen2(true);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default CourseProList1;
